import UnrecognizedIdentifier from './UnrecognizedIdentifier';

export default UnrecognizedIdentifier;
